export const BASE_URL = "https://soft-smoke-35426.botics.co/" // your app back-end url

// export const BASE_URL = "https://464f-119-154-217-169.ngrok-free.app/"

export const GOOGLE_CLIENT_ID_IOS =
  "685154748583-bq28qhmhcovcb3j2hnnclh12cs0b976u.apps.googleusercontent.com"

export const GOOGLE_CLIENT_ID_ANDROID =
  "685154748583-hucsna665361l8g6qjfjfnm9q2u8cbhh.apps.googleusercontent.com"
